/**
 * 
 */
import { InnovationShort } from './innovationShort.model';
import { InnovationDocument } from './innovationDocument.model';
export class Innovation extends InnovationShort {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public document: InnovationDocument[]; /*Приказ*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.document = [];
        if (json.document) {
          for (const i in json.document) {
            if ( json.document.hasOwnProperty( i ) ) {
                this.document.push(new InnovationDocument(json.document[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
